import type { AgentPageContext } from '@/modules/personal-agent-api';
import type { Signal } from '@/modules/score-api';

// The agent sees a market as structured data, not a page scrape, and nothing
// the backend didn't return; `marketId` rides along so the agent's own notes
// can reference it.
export function marketPageContext(signal: Signal): AgentPageContext {
  return {
    url: window.location.href,
    title: document.title,
    description: `Prediction market ${signal.asset}/${signal.quoteAsset} based on @${signal.kol.handle}'s call`,
    data: {
      marketId: signal.id,
      asset: signal.asset,
      quoteAsset: signal.quoteAsset,
      direction: signal.direction,
      kolHandle: signal.kol.handle,
      tweetText: signal.tweetText,
      entryPrice: signal.entryPrice,
      votingEndsAt: signal.votingEndsAt,
      resolvesAt: signal.resolvesAt,
    },
  };
}
